import React, { useContext, useEffect, useState } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";

import "../../../assets/css/user/cart/Checkout.css";

import Footer from "../../../components/user/footer/Footer";
import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../../../components/user/general/SimpleBanner";

import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import axios from "axios";

import AppContext from "../../../context/AppContext";

import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";

export default function Checkout() {

  const {
    baseUrl,
    loggedInUser,
    loggedInCustomer,
  } = useContext(AppContext);

  const navigate = useNavigate();

  const location = useLocation();

  const [orders, setOrders] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  // =========================================================
  // GET CUSTOMER
  // =========================================================

  const getCustomer = () => {

    if (loggedInUser?.id) {
      return loggedInUser;
    }

    if (loggedInCustomer?.id) {
      return loggedInCustomer;
    }

    try {

      const savedUser =
        JSON.parse(
          localStorage.getItem(
            "loggedInUser"
          )
        ) || null;

      if (savedUser?.id) {
        return savedUser;
      }

      const savedCustomer =
        JSON.parse(
          localStorage.getItem(
            "loggedInCustomer"
          )
        ) || null;

      if (savedCustomer?.id) {
        return savedCustomer;
      }

    } catch (error) {

      console.log(
        "Customer localStorage error:",
        error
      );

    }

    return null;
  };

  // =========================================================
  // FETCH CUSTOMER ORDERS
  // Used only when checkout page is refreshed/directly opened
  // =========================================================

  const fetchCustomerOrders = async () => {

    try {

      setLoading(true);

      setError("");

      const customer =
        getCustomer();

      if (!customer?.id) {

        setError(
          "Customer information was not found."
        );

        setLoading(false);

        return;
      }

      console.log(
        "Fetching orders for customer:",
        customer.id
      );

      const formData =
        new FormData();

      formData.append(
        "tpcustomer_id",
        customer.id
      );

      const response =
        await axios.post(
          `${baseUrl}/customer/orders/fetchCustomerOrders`,
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );

      console.log(
        "Customer Orders Response:",
        response.data
      );

      if (
        response.data?.success
      ) {

        const returnedOrders =
          response.data?.orders ||
          [];

        if (
          returnedOrders.length >
          0
        ) {

          setOrders(
            returnedOrders
          );

        } else {

          setError(
            "No order was found for this customer."
          );

        }

      } else {

        setError(
          response.data?.message ||
            "Unable to load your order."
        );

      }

    } catch (err) {

      console.error(
        "FETCH ORDERS ERROR:",
        err
      );

      console.error(
        "Backend Response:",
        err?.response?.data
      );

      setError(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Unable to load your order. Please try again."
      );

    } finally {

      setLoading(false);

    }

  };

  // =========================================================
  // FIRST LOAD
  //
  // IMPORTANT:
  // If Cart already created the order, use location.state.orders
  // instead of immediately searching the database.
  // =========================================================

  useEffect(() => {

    const stateOrders =
      location.state?.orders;

    if (
      Array.isArray(stateOrders) &&
      stateOrders.length > 0
    ) {

      console.log(
        "Orders received from Cart:",
        stateOrders
      );

      setOrders(
        stateOrders
      );

      setError("");

      setLoading(false);

      return;

    }

    // If user refreshes checkout page,
    // get orders from backend.

    fetchCustomerOrders();

  }, [
    baseUrl,
    location.state,
  ]);

  // =========================================================
  // ALL CART ITEMS
  // =========================================================

  const allCarts =
    orders.flatMap(
      (order) => {

        if (
          !order ||
          !Array.isArray(
            order.tpcarts
          )
        ) {
          return [];
        }

        return order.tpcarts.filter(
          (cart) => cart
        );

      }
    );

  // =========================================================
  // SUBTOTAL
  // =========================================================

  const subTotal =
    allCarts.reduce(
      (sum, cart) => {

        return (
          sum +
          Number(
            cart?.tpdeal
              ?.actual_price ||
              0
          )
        );

      },
      0
    );

  // =========================================================
  // DEAL TOTAL
  // =========================================================

  const dealTotal =
    allCarts.reduce(
      (sum, cart) => {

        return (
          sum +
          Number(
            cart?.tpdeal
              ?.deal_price ||
              0
          )
        );

      },
      0
    );

  // =========================================================
  // ORDER TOTAL
  // =========================================================

  const orderTotal =
    orders.reduce(
      (sum, order) => {

        return (
          sum +
          Number(
            order?.amount ||
              0
          )
        );

      },
      0
    );

  const finalTotal =
    orderTotal > 0
      ? orderTotal
      : dealTotal;

  // =========================================================
  // DISCOUNT
  // =========================================================

  const discountAmount =
    Math.max(
      subTotal -
        dealTotal,
      0
    );

  const discountPercentage =
    subTotal > 0
      ? Math.round(
          (discountAmount /
            subTotal) *
            100
        )
      : 0;

  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {

    return (
      <div className="checkout-page">

        <MarqueeBanner />

        <Navbar />

        <SimpleBanner
          title="Checkout"
          subtitle=""
          breadcrumbs={[
            {
              label: "Home",
              href: "/",
            },
            {
              label: "Checkout",
              href: "/checkout",
            },
          ]}
        />

        <Container fluid>

          <Row className="checkout-body g-4">

            <Col xs={12}>

              <Card className="checkout-card done-card">

                <Card.Body className="text-center py-5">

                  <Spinner
                    animation="border"
                    role="status"
                    className="mb-3"
                  />

                  <h2 className="done-title">
                    Processing Your Order...
                  </h2>

                  <p className="done-sub">
                    Please wait.
                  </p>

                </Card.Body>

              </Card>

            </Col>

          </Row>

        </Container>

        <Footer />

      </div>
    );
  }

  // =========================================================
  // ERROR
  // =========================================================

  if (
    error ||
    orders.length === 0
  ) {

    return (
      <div className="checkout-page">

        <MarqueeBanner />

        <Navbar />

        <SimpleBanner
          title="Checkout"
          subtitle=""
          breadcrumbs={[
            {
              label: "Home",
              href: "/",
            },
            {
              label: "Checkout",
              href: "/checkout",
            },
          ]}
        />

        <Container fluid>

          <Row className="checkout-body g-4">

            <Col xs={12}>

              <Card className="checkout-card done-card">

                <Card.Body className="text-center py-5">

                  <div
                    className="done-icon"
                    style={{
                      fontSize:
                        "48px",
                      marginBottom:
                        "15px",
                    }}
                  >
                    ❌
                  </div>

                  <h2 className="done-title">
                    Unable to Complete Order
                  </h2>

                  <Alert
                    variant="danger"
                    className="mt-3"
                  >
                    {error ||
                      "No order was found for this customer."}
                  </Alert>

                  <p className="done-sub">
                    Please go back to your cart
                    and try again.
                  </p>

                  <div
                    className="d-flex justify-content-center gap-2 flex-wrap"
                  >

                    <Button
                      className="btn-checkout"
                      onClick={() =>
                        navigate("/cart")
                      }
                    >
                      Back to Cart
                    </Button>

                    <Button
                      variant="outline-secondary"
                      onClick={() =>
                        fetchCustomerOrders()
                      }
                    >
                      Try Again
                    </Button>

                  </div>

                </Card.Body>

              </Card>

            </Col>

          </Row>

        </Container>

        <Footer />

      </div>
    );
  }

  // =========================================================
  // SUCCESS
  // =========================================================

  return (
    <div className="checkout-page">

      <MarqueeBanner />

      <Navbar />

      <SimpleBanner
        title="Checkout"
        subtitle=""
        breadcrumbs={[
          {
            label: "Home",
            href: "/",
          },
          {
            label: "Checkout",
            href: "/checkout",
          },
        ]}
      />

      <Container fluid>

        <Row className="checkout-body g-4">

          {/* =================================================
              LEFT
          ================================================= */}

          <Col xs={12} lg={8}>

            <Card className="checkout-card done-card">

              <Card.Body className="text-center">

                <div
                  className="done-icon"
                  style={{
                    fontSize:
                      "52px",
                    marginBottom:
                      "10px",
                  }}
                >
                  ✅
                </div>

                <h2 className="done-title">
                  Order Placed!
                </h2>

                <p className="done-sub">
                  Your order has been placed
                  successfully.
                </p>

                {/* =================================================
                    ORDERS
                ================================================= */}

                <div className="done-details">

                  {orders.map(
                    (
                      order,
                      orderIndex
                    ) => (

                      <div
                        key={
                          order?.id ||
                          `order-${orderIndex}`
                        }
                        className="mb-4"
                      >

                        <div
                          className="d-flex justify-content-between align-items-center mb-2"
                          style={{
                            borderBottom:
                              "1px solid #eee",
                            paddingBottom:
                              "10px",
                          }}
                        >

                          <strong>
                            Order #
                            {order?.id ||
                              "—"}
                          </strong>

                          <span
                            style={{
                              fontSize:
                                "13px",
                              color:
                                "#666",
                            }}
                          >
                            {order
                              ?.created_at
                              ? new Date(
                                  order.created_at
                                ).toLocaleDateString(
                                  "en-GB"
                                )
                              : ""}
                          </span>

                        </div>

                        {/* ITEMS */}

                        {Array.isArray(
                          order?.tpcarts
                        ) &&
                        order.tpcarts
                          .length >
                          0 ? (

                          order.tpcarts.map(
                            (
                              cart,
                              cartIndex
                            ) => (

                              <div
                                className="done-item"
                                key={
                                  cart?.id ||
                                  `item-${cartIndex}`
                                }
                              >

                                <span>
                                  {cart
                                    ?.tpdeal
                                    ?.deal_title ||
                                    "Deal"}
                                </span>

                                <span>
                                  PKR{" "}
                                  {Number(
                                    cart
                                      ?.tpdeal
                                      ?.deal_price ||
                                      0
                                  ).toLocaleString()}
                                </span>

                              </div>

                            )
                          )

                        ) : (

                          <div className="done-item">

                            <span>
                              Order Amount
                            </span>

                            <span>
                              PKR{" "}
                              {Number(
                                order?.amount ||
                                  0
                              ).toLocaleString()}
                            </span>

                          </div>

                        )}

                      </div>

                    )
                  )}

                </div>

                {/* =================================================
                    SHIPPING
                ================================================= */}

                {orders.length >
                  0 && (

                  <div
                    style={{
                      marginTop:
                        "25px",
                      padding:
                        "18px",
                      background:
                        "#f8f9fa",
                      borderRadius:
                        "10px",
                      textAlign:
                        "left",
                    }}
                  >

                    <h5
                      style={{
                        marginBottom:
                          "15px",
                        fontWeight:
                          "600",
                      }}
                    >
                      Shipping Information
                    </h5>

                    <p>
                      <strong>
                        Name:
                      </strong>{" "}
                      {orders[0]
                        ?.shipping_name ||
                        "—"}
                    </p>

                    <p>
                      <strong>
                        Phone:
                      </strong>{" "}
                      {orders[0]
                        ?.shipping_phone ||
                        "—"}
                    </p>

                    <p>
                      <strong>
                        Address:
                      </strong>{" "}
                      {orders[0]
                        ?.shipping_address ||
                        "—"}
                    </p>

                    <p>
                      <strong>
                        City:
                      </strong>{" "}
                      {orders[0]
                        ?.shipping_city ||
                        "—"}
                    </p>

                    {orders[0]
                      ?.shipping_postal_code && (

                      <p
                        style={{
                          marginBottom:
                            "0",
                        }}
                      >
                        <strong>
                          Postal Code:
                        </strong>{" "}
                        {
                          orders[0]
                            .shipping_postal_code
                        }
                      </p>

                    )}

                  </div>

                )}

                {/* =================================================
                    PAYMENT
                ================================================= */}

                {/* <div
                  style={{
                    marginTop:
                      "18px",
                    padding:
                      "12px 15px",
                    background:
                      "#ecfdf5",
                    border:
                      "1px solid #a7f3d0",
                    borderRadius:
                      "8px",
                    color:
                      "#047857",
                    fontWeight:
                      "600",
                  }}
                >
                  Payment Status: Paid
                </div> */}

                <Button
                  className="btn-checkout mt-4"
                  onClick={() =>
                    navigate("/")
                  }
                >
                  Continue Shopping
                </Button>

              </Card.Body>

            </Card>

          </Col>

          {/* =================================================
              RIGHT
          ================================================= */}

          <Col xs={12} lg={4}>

            <Card className="summary-card">

              <Card.Body>

                <h3 className="summary-title">
                  Order Summary
                </h3>

                <div className="summary-row">

                  <span>
                    Subtotal
                  </span>

                  <span>
                    PKR{" "}
                    {Number(
                      subTotal
                    ).toLocaleString()}
                  </span>

                </div>

                {discountPercentage >
                  0 && (

                  <div className="summary-row discount">

                    <span>
                      Discount (
                      {
                        discountPercentage
                      }
                      %)
                    </span>

                    <span>
                      - PKR{" "}
                      {Number(
                        discountAmount
                      ).toLocaleString()}
                    </span>

                  </div>

                )}

                <hr className="summary-divider" />

                <div className="summary-row total">

                  <span>
                    Total
                  </span>

                  <span>
                    PKR{" "}
                    {Number(
                      finalTotal
                    ).toLocaleString()}
                  </span>

                </div>

              </Card.Body>

            </Card>

          </Col>

        </Row>

      </Container>

      <Footer />

    </div>
  );
}